import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { IconInvalid } from 'src/easyclaim.app.assets';

import styles from './styles/Slider.module.css';

interface SliderProps {
	isOpen: boolean;
	title: ReactElement;
	onClose: () => void;
	children?: ReactNode;
}

export const Slider = ({ title, isOpen, onClose, children }: SliderProps) => {
	const [isClosing, setIsClosing] = useState(false);
	const closeTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		return () => {
			if (closeTimeoutRef.current) {
				clearTimeout(closeTimeoutRef.current);
			}
		};
	}, []);

	const handleClose = () => {
		setIsClosing(true);
		closeTimeoutRef.current = setTimeout(() => {
			setIsClosing(false);
			onClose();
		}, 300);
	};

	if (!isOpen && !isClosing) return null;

	return (
		<>
			<div
				className={`${styles.overlay} ${isClosing ? styles.overlayClosing : ''}`}
				onClick={handleClose}
			/>
			<div className={`${styles.modal} ${isClosing ? styles.modalClosing : ''}`}>
				<div className={styles.sliderHeaderSpacer} />
				<div className={styles.sliderTitleContainer}>
					<div className={styles.sliderTitle}>{title}</div>
				</div>

				<IconInvalid className={styles.sliderCloseButton} onClick={handleClose} />
				<div className={styles.sliderContent}>{children}</div>
			</div>
		</>
	);
};
